import { isValidElement } from "react";
function isChildOfType(element, type) {
  return isValidElement(element) && element.type === type;
}
function getFirstChildOfType(children, type) {
  var childArray = Array.isArray(children) ? children : [
    children
  ];
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = childArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var child = _step.value;
      if (isChildOfType(child, type)) {
        return child;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return void 0;
}
function getAllChildrenOfType(children, type) {
  var childArray = Array.isArray(children) ? children : [
    children
  ];
  return childArray.filter(function(child) {
    return isChildOfType(child, type);
  });
}
function getAllChildrenNotOfType(children, type) {
  var childArray = Array.isArray(children) ? children : [
    children
  ];
  return childArray.filter(function(child) {
    return !isChildOfType(child, type);
  });
}
function filterAllowedChildrenElements(children, allowedTypes) {
  var childArray = Array.isArray(children) ? children : [
    children
  ];
  return childArray.filter(function(child) {
    return isValidElement(child) && allowedTypes.some(function(type) {
      return child.type === type;
    });
  });
}
export {
  filterAllowedChildrenElements,
  getAllChildrenNotOfType,
  getAllChildrenOfType,
  getFirstChildOfType,
  isChildOfType
};
//# sourceMappingURL=children.js.map
